import { FilterAltOff as FilterAltOffIcon, Refresh as RefreshIcon, Upload as UploadIcon } from '@mui/icons-material'
import { Box, Button, Stack } from '@mui/material'
import { EProcessingStatus } from '@src/types/automationDocument'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AssignSection from './AssignSection'
import FilterSection from './FilterSection'
import ImportDialog from './ImportDialog'
import SearchSection from './SearchSection'

export interface ManualDocsAutomationFiltersType {
  clientNameContains: string | null
  email: string | null
  tagSearch?: string | null
  status?: EProcessingStatus[] | null
  tags?: string[] | null
}

interface DocumentListToolbarProps {
  onFiltersChange: (filters: Partial<ManualDocsAutomationFiltersType>) => void
  defaultValues?: ManualDocsAutomationFiltersType | null
  onRefresh?: () => void
  onClearFilters?: () => void
  showAssignEmails?: boolean
}

const DocumentListToolbar = ({
  onFiltersChange,
  defaultValues,
  onRefresh,
  onClearFilters,
  showAssignEmails,
}: DocumentListToolbarProps) => {
  const { t } = useTranslation()
  const [importOpen, setImportOpen] = useState(false)

  return (
    <>
      <Stack spacing={1} sx={{ p: 2, pb: 1 }}>
        {/* Row 2: Filters + Assign */}
        <Stack direction="row" spacing={1} rowGap={1} alignItems="center" flexWrap="wrap" useFlexGap>
          <Stack direction="row" spacing={1} alignItems="center" data-tour="search-and-filters">
            <SearchSection defaultValues={defaultValues} onFiltersChange={onFiltersChange} />
            <FilterSection defaultValues={defaultValues} onFiltersChange={onFiltersChange} />
          </Stack>
          {onClearFilters && (
            <Button size="small" variant="text" startIcon={<FilterAltOffIcon />} onClick={onClearFilters} sx={{ textTransform: 'none' }}>
              {t('common.clearFilters')}
            </Button>
          )}
          {showAssignEmails && <AssignSection />}
          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="contained"
            size="small"
            startIcon={<UploadIcon />}
            onClick={() => setImportOpen(true)}
            sx={{ whiteSpace: 'nowrap' }}
            data-tour="import-button"
          >
            {t('common.importContent')}
          </Button>
          <Button
            size="small"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
            sx={{ textTransform: 'none' }}
          >
            {t('common.refresh')}
          </Button>
        </Stack>
      </Stack>

      <ImportDialog open={importOpen} onClose={() => setImportOpen(false)} />
    </>
  )
}

export default DocumentListToolbar
